import React, { PropTypes } from 'react';
import { Dialog } from 'material-ui';
import ServiceNow from './ServiceNow';
import Breakpoint from '../../utils/breakpoints';

const dialogStyle = {
  width: '600px',
  borderRadius: '4px',
  boxShadow: '-10px 9px 21px 0 rgba(128, 152, 213, 0.08)',
  border: 'solid 1px #b2beda'
};

const mobileDialogStyle = {
  width: '100%',
  height: '100%',
  maxHeight: 'none',
  maxWidth: 'none'
};

const bodyStyle = {
  padding: 'none',
  height: '100%',
  maxHeight: 'none'
};

class ServiceNowDialog extends React.Component {
  render() {
    const { open, handleClose } = this.props;

    return (
      <div>
        <Breakpoint name="tabletDesktop">
          <Dialog
            modal={false}
            contentStyle={dialogStyle}
            open={open}
            onRequestClose={handleClose}
            bodyStyle={bodyStyle}>
            <ServiceNow handleClose={handleClose} open={open} />
          </Dialog>
        </Breakpoint>
        <Breakpoint name="mobile">
          <Dialog
            modal={false}
            contentStyle={mobileDialogStyle}
            autoScrollBodyContent
            open={open}
            onRequestClose={handleClose}
            autoDetectWindowHeight={false}
            bodyStyle={bodyStyle}>
            <ServiceNow handleClose={handleClose} open={open} />
          </Dialog>
        </Breakpoint>
      </div>
    );
  }
}

ServiceNowDialog.propType = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default ServiceNowDialog;



// WEBPACK FOOTER //
// ./src/features/Servicenow/ServiceNowDialog.js